import CollapsibleDataTable from '../components/TableWithCollapsibleRows';
import { SubstituteProductDataProps } from '../interface/interface';

const SubstituteTokenTable = (props: SubstituteProductDataProps) => {
  const visibleColumns = [
    'Token',
    'Product Name',
    'Prescribed Qty',
    'Remaining Repeats',
  ];

  return (
    <div>
      <CollapsibleDataTable
        data={props.data}
        visibleColumns={visibleColumns}
        hiddenColumns={[]}
        withRadioButtons={true}
        alwaysOpen={false}
        className="Substitute-token-table"
        handleTokenRadio={props.token}
        handleSubTokenRadio={props.substituteToken}
        step={props.step}
      />
    </div>
  );
};

export default SubstituteTokenTable;
